import { router, useLocalSearchParams } from "expo-router";
import * as z from "zod";

import { icons } from "~/lib/constants";

export const BACKLOG_SLUG = "backlog";

export type Params = {
  isSelecting: "true" | "false";
  ids: Array<string>;
  space: string;
  collectionId: string;
  tagId: string;
  sort: "date-asc" | "date-desc" | "title-asc" | "title-desc";
  filters?: string;
  search?: string;
};

export function setParams(params: Partial<Params>) {
  router.setParams(params);
}

export function useParams() {
  return useLocalSearchParams<Params>();
}

export const SAVE_TYPE_OPTIONS = [
  {
    type: "URL",
    title: "Link",
    icon: icons.link.web,
  },
  {
    type: "MEDIA",
    title: "Media",
    icon: icons.media.web,
  },
  {
    type: "FILE",
    title: "File",
    icon: icons.file.web,
  },
  {
    type: "NOTE",
    title: "Note",
    icon: icons.note.web,
  },
] as const;

export const filterSchema = z.object({
  collection: z.object({
    ids: z.array(z.string()).default([]),
    mode: z
      .enum(["is", "is_not", "is_any_of", "is_none_of", "is_all_of"])
      .default("is"),
  }),

  tag: z.object({
    ids: z.array(z.string()).default([]),
    mode: z
      .enum(["is", "is_not", "is_any_of", "is_none_of", "is_all_of"])
      .default("is"),
  }),

  saveType: z
    .object({
      // calling ID to make code easier
      ids: z.array(z.enum(["URL", "MEDIA", "FILE", "NOTE"])).default([]),
      mode: z.enum(["is", "is_not", "is_any_of", "is_none_of"]).default("is"),
    })
    .optional(),
});

export type FilterSchema = z.infer<typeof filterSchema>;

export function encodeFilterForURL(filter: FilterSchema) {
  return btoa(JSON.stringify(filter));
}

export function decodeFilterFromURL(filter: string = "") {
  const parsed = filterSchema.safeParse(filter ? JSON.parse(atob(filter)) : "");
  if (parsed.success) {
    return parsed.data;
  }

  return null;
}
